import React from "react";
import { Router, Location } from "@reach/router";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import Lesson from "./Lesson";
import { fetchDataFile } from "../components/Fetch";
import ReactHtmlParser from "react-html-parser";
import LeftColumn from "./columns/LeftColumn";
import RightColumn from "./columns/RightColumn";
import Footer from "./elements/Footer";
import {I18nContext } from '../containers/i18n/I18nProvider';
import "../styles/programmation.css";

class Programmation extends React.Component {

  static contextType = I18nContext;

  constructor(props) {
    super(props);

    this.state = {
      lessonId: undefined,
      htmlContent: null
    };

    this.onLoadComplete = this.onLoadComplete.bind(this);
    this.updateContainerHeight = this.updateContainerHeight.bind(this);
    this.updateState = this.updateState.bind(this);
  }

  componentDidMount() {
    fetchDataFile(this.props.url, "", this.onLoadComplete);
  }

  onLoadComplete(data) {
    const page = ReactHtmlParser(data);
    this.setState({ htmlContent: page });
  }
  updateState(o) {
    const s = Object.assign({}, this.state, o);
    this.setState(s);
  }
  updateContainerHeight(h) {
    const mc = document.getElementById("mainContainer");
    if (mc) mc.style.height = h + 384 + "px";
  }
  render() {
    const content = this.state.htmlContent;
    const s = {};
    return (
      <>
        <div id="mainContainer" className="mainContainer" style={s}>
          <LeftColumn page="programmation" />
          <RightColumn page="programmation" />
          <div className="page programmation">
            <div className="subContainer">{content}</div>

            <FadeTransitionRouter
              updateState={this.updateState}
              currentLessonId={this.state.lessonId}
            >
              <Lesson
                path="/"
                menu={this.props.menu}
                updateContainerHeight={this.updateContainerHeight}
                lang={this.context.lang}
              />
              <Lesson
                path="lesson/:lessonId"
                updateContainerHeight={this.updateContainerHeight}
                lang={this.context.lang}
              />
            </FadeTransitionRouter>
            {this.props.children}
          </div>
        </div>
        {!this.state.lessonId && <Footer />}
      </>
    );
  }
}

const FadeTransitionRouter = props => {
  return (
    <Location>
      {({ location }) => {
        const lessonId = location.pathname.split("lesson/")[1];
        if (lessonId !== props.currentLessonId) props.updateState({ lessonId });
        return (
          <TransitionGroup className="transition-group">
            <CSSTransition key={location.key} classNames="fade" timeout={500}>
              <Router location={location} className="router">
                {props.children}
              </Router>
            </CSSTransition>
          </TransitionGroup>
        );
      }}
    </Location>
  );
};

export default Programmation;
